import { render, staticRenderFns } from "./DynamicZoneRenderer.vue?vue&type=template&id=0b82a6be&"
import script from "./DynamicZoneRenderer.vue?vue&type=script&lang=js&"
export * from "./DynamicZoneRenderer.vue?vue&type=script&lang=js&"
import style0 from "./DynamicZoneRenderer.vue?vue&type=style&index=0&id=0b82a6be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports